import styled from 'styled-components';
type Props = {};

export default styled.section<Props>``;
export const SitesChargeStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
